import { Link } from "react-router";

export default function NotFound() {
  return (
    <div className="ph" style={{ display: "grid", gap: 12 }}>
      <h1>Not found</h1>
      <p className="muted" style={{ margin: 0 }}>
        Nothing lives at this address. <Link to="/" className="link">Back to your shows</Link>.
      </p>
    </div>
  );
}
